import _ from 'lodash';
import React from 'react';
import { useContext, useState } from 'react';

import LegoAdminPageContext from '../../../pages/legoAdminPageContext';
import useAsyncEffect from '../../common/react-hooks/useAsyncEffect';
import { LocalesSelector } from '../LocalesSelector';
import { Icon } from '../../common/Icon';
import LegoLabel from '../LegoLabel';
import { SwitchInput } from '../../common/SwitchInput';
import { LocaleFlag } from '../LocaleFlag';
import LegoEditButton from '../LegoEditButton';
import { FuseboxTranslationTable } from './FuseboxTranslationTable';

export function ModalTranslateFusebox({ lego, onTranslationDone }) {
  let [boxes, setBoxes] = useState(lego.data.map(() => true));
  let [locale, setLocales] = useState(['es', 'en', 'pt'].filter(loc => _.some(lego.labels, l => l === `translateTo:${loc}` || l.startsWith(`translatedTo:${loc}`)))[0]);

  const getIdFromLabels = (locale) => _.compact(_.map(lego.labels, l => l.match(new RegExp(`^translatedTo:${locale}_(\\w+)$`, 'i'))?.[1]))[0];

  let [translationId, setId] = useState(getIdFromLabels(locale));
  let [translatedLego, setTranslatedLego] = useState(null);
  let { page } = useContext(LegoAdminPageContext);

  const updateTranslatedLego = async () => {
    if (translationId) {
      setTranslatedLego(await page.service('services/legos').get(translationId));
    } else {
      setTranslatedLego(null);
    }
  };

  useAsyncEffect(updateTranslatedLego, [translationId]);

  const translate = () => {
    let params = { _id: lego._id, boxesToTranslate: boxes, targetLocale: locale };
    page.runAsync(async () => {
      let newLegoId = await page.service('services/data/fusebox-translation').create(params);
      setId(newLegoId);
      onTranslationDone(newLegoId);
    }, 'Translating...');
  };

  const updateTranslation = () => {
    let params = { boxesToTranslate: boxes, save: true };
    page.runAsync(async () => {
      let newLegoId = await page.service('services/data/fusebox-translation').update(translationId, params);
      updateTranslatedLego();
      onTranslationDone(newLegoId);
    }, 'Translating...');
  };

  const ellipsis = (s, n = 40) => (s || '').slice(0, n) + (s?.length > n ? '...' : '');

  const setBox = (i, checked) => {
    boxes[i] = checked;
    setBoxes([...boxes]);
  };


  return <div>
    <div className={'text-center'}>
      <div className={'text-center mb-3'}>
        Translate to: <LocalesSelector multi={false} value={locale} onChange={(v) => {
        setLocales(v);
        setId(getIdFromLabels(v));
      }}/>
      </div>

      {locale && _.some(boxes) && !translatedLego ?
        <>
          <button onClick={translate} className={'btn btn-success mr-2'}>
            <Icon icon={'translate'}/> Translate selected boxes to <LocaleFlag locale={locale}/>
          </button>
        </> : null}

      {locale && _.some(boxes) && translatedLego
        ?
        <button onClick={updateTranslation} className={'btn btn-primary mr-2'}>
          <Icon icon={'refresh'}/> Update translation
        </button>
        : null}

      {translationId ? <>

        <LegoLabel className={'ml-2'} label={`translatedTo:${locale}_${translationId}`}/>
        <LegoEditButton legoId={translationId}>{translationId}</LegoEditButton>
      </> : null}

    </div>

    <FuseboxTranslationTable 
      originalBoxes={lego.data} 
      translatedBoxes={translatedLego ? translatedLego.data.map((tb, i) => tb.isTranslated ? tb : null) : null} 
      boxesChecked={boxes} 
      onBoxCheck={setBox} 
    />
  </div>;
}
